import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Storage } from '@ionic/storage';
import { NavController, ToastController } from '@ionic/angular';

import { Platform } from '@ionic/angular';
import { LoadingService } from '../services/loading.service';


@Injectable({
	providedIn: 'root'
})
export class ApiService {
	url = environment.apiUrl
	users: any;
	templates: any;
	userTemplates:any

	constructor(
		public loading: LoadingService,
		private http: HttpClient,
		private storage: Storage,
		private navCtrl: NavController,
		public toastController: ToastController,
		private platform: Platform,
	) {

	}

	open(uri, data) {
		return new Promise((resolve, reject) => {
			this.http.post(this.url + uri, data)
			.subscribe(response => {
				resolve(response);
			},
			(error) => {
				if(error.error.message=='Too Many Attempts.') {
					let errors = {errors:{email:['Too Many Attempts, Login after sometimes']}};
					reject(errors);
				}
				else {
					reject(error.error);
				}
			});
		});
	}

	httpCall(uri,data,token) {
	    return new Promise((resolve, reject) => {
	        this.http.post(this.url+uri, data, {
	            headers: new HttpHeaders().set('Authorization', 'Bearer' + ' ' + token)
	        })
	        .subscribe(response => {
	            resolve(response);	
	        }, 
	        (error) => {
				if(error.error.message=='Unauthenticated.') {
					this.storage.remove('user');
					this.navCtrl.navigateRoot('/');
					this.presentToast()
					let errors = {errors:{email:['Unauthenticated.']}};
					reject(errors);
				}
				else {
					reject(error.error);
				}
	        });
	    });
	}

	// open(uri, data) {
	// 	return new Promise((resolve, reject) => {
	// 		this.httpSsl.post(this.url + uri, data, {})
	// 			.then(response => {
	// 				resolve(JSON.parse(response.data));
	// 			})
	// 			.catch(error => {
	// 				if (error.status == '429') {
	// 					let errors = { errors: { email: ['Too Many Attempts, Login after sometimes'] } };
	// 					reject(errors);
	// 				}
	// 				else {
	// 					reject(JSON.parse(error.error));
	// 				}
	// 			})
	// 	});
	// }

	// httpCall(uri, data, token) {
	// 	return new Promise((resolve, reject) => {
	// 		this.httpSsl.post(this.url + uri, data, {
	// 			Authorization: 'Bearer' + ' ' + token
	// 		})
	// 			.then(response => {
	// 				resolve(JSON.parse(response.data));
	// 			})
	// 			.catch(error => {
	// 				console.log(error);
	// 				if (error.status == '500') {
	// 					this.storage.remove('user');
	// 					this.navCtrl.navigateRoot('/');
	// 					this.presentToast()
	// 					let errors = { errors: { email: ['Unauthenticated.'] } };
	// 					reject(errors);
	// 				}
	// 				else {
	// 					reject(JSON.parse(error.error));
	// 				}
	// 			})
	// 	});
	// }

	logout() {
		this.storage.remove('user');
		this.navCtrl.navigateRoot('/');
		
	}

	async presentToast() {
		const toast = await this.toastController.create({
			message: 'Unauthenticated. Please Login.',
			duration: 1000,
		});
		toast.present();
	}
}